import React, { useCallback, useState } from 'react'
import { Alert, Box, Space, useFocus } from '@ally/metronome-ui'
import { AcctNickname } from './AcctNickname'
import { AcctNicknameForm } from './AcctNicknameForm'
import { AccountDetails } from '../../../types'
import { useAccountDetailsContext } from '../../../services/AccountDetailsProvider'

interface NickNameProps {
  account: AccountDetails
}

export const NickName: React.FC<NickNameProps> = ({ account }) => {
  const [isDetailsCardError, setIsDetailsCardError] = useState(false)
  const [isEditNickname, setIsEditNickname] = useState(false)
  const [isNicknameEditLoading, setIsNicknameEditLoading] = useState(false)
  const [hasCancelled, setHasCancelled] = useState(false)
  const [editNicknameButtonRef, setFocusToEditNicknameButton] =
    useFocus<HTMLButtonElement>()

  const { updateAccountNickname } = useAccountDetailsContext()

  React.useLayoutEffect(() => {
    /* istanbul ignore if */
    if (!isEditNickname && hasCancelled) {
      setFocusToEditNicknameButton()
    }
  }, [isEditNickname, setFocusToEditNicknameButton, hasCancelled])

  // TODO - add test and coverage
  /* istanbul ignore next */
  const updateNickname = useCallback(
    async (accountNickname: string) => {
      setIsNicknameEditLoading(true)
      setIsDetailsCardError(false)
      try {
        await updateAccountNickname(accountNickname)
      } catch (error) {
        setIsDetailsCardError(true)
      } finally {
        setIsNicknameEditLoading(false)
      }
    },
    [setIsNicknameEditLoading, setIsDetailsCardError, updateAccountNickname],
  )
  /* istanbul ignore next */
  const onNicknameFormCancel = (): void => {
    setHasCancelled(true)
  }

  // TODO - add test and coverage
  /* istanbul ignore next */
  return (
    <Box>
      {isDetailsCardError && (
        <Space my="sm">
          <Alert
            disableContainer
            variant="error"
            heading="We can't complete your request right now. Try again later, or call us for help."
          />
        </Space>
      )}
      {isEditNickname ? (
        <AcctNicknameForm
          account={account}
          setIsEdit={setIsEditNickname}
          updateNickname={updateNickname}
          isLoading={isNicknameEditLoading}
          onCancel={onNicknameFormCancel}
        />
      ) : (
        <AcctNickname
          account={account}
          setIsEdit={setIsEditNickname}
          setIsDetailsCardError={setIsDetailsCardError}
          editButtonRef={editNicknameButtonRef}
        />
      )}
    </Box>
  )
}
